<script lang="ts">
  import Editor from '../../shared/Editor.svelte'
  import {t} from '../../i18n'
  import api from '../../api/api'
  import type {Poem} from '../../types'
  import ValidationMessage from '../../shared/ValidationMessage.svelte'

  export let poem: Poem
  export let stepTo: (e: Event, stepIndex: number) => void
  let error: string | undefined

  async function uploadPicture(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement
    if (!input.files || input.files.length === 0) return

    const formData = new FormData()
    formData.append('poem[image]', input.files[0])

    const response = await api.put<Poem>(`/poems/${poem.id}`, formData)

    poem.image_url = response.image_url
    poem.image_present = response.image_present
    poem.preview_image = response.preview_image
  }

  function deleteImage(): void {
    poem.image_present = false
    poem.image_url = ''
    poem.preview_image = ''
  }

  export function validate(): boolean {
    if (!poem.preview || poem.preview.trim().length === 0) {
      error = t.errors.validation.html_content_required
      return false
    }
    
    // Truncate preview if it's longer than 250 characters
    if (poem.preview.length > 250) {
      poem.preview = poem.preview.substring(0, 250) + '...'
    }
    
    error = undefined
    return true
  }
</script>

<div class="form add__cover__block dropzone">
  <h4>{poem.title}</h4>

  {#if !poem.image_present}
    <div class="dropzone cover-dropzone">
      <label for="cover">{t.poem.form.cover.add}</label>
      <input id="cover" type="file" onchange={uploadPicture} style="display: none;"/>
    </div>
  {:else}
    <div>
      <label for="image2">
        <span class="wh_round icon-p-share"></span>
        <input id="image2" type="file" onchange={uploadPicture} style="display: none;"/>
      </label>
      <span class="wh_round icon-p-trash" onclick={deleteImage}/>

      <img src={poem.preview_image} alt="Cover Preview" width="300"/>
    </div>
  {/if}

  <Editor bind:content={poem.preview} placeholder={t.poem.preview_placeholder} class="preview__text"/>
  <div class="small-title">{t.poem.form.cover.change_preview}</div>

  {#if error}
    <ValidationMessage errors={[error]}/>
  {/if}
  
  <div class="step-button-wrap">
    <a class="ui button inverted" onclick={(e) => stepTo(e, 3)}>
      {t.poem.steps.continue}
    </a>
  </div>
</div>
